import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiProperty, ApiTags } from "@nestjs/swagger";
import { ExpensesService } from "./expenses.service";
import { ExpensesDTO } from "./expenses.dto";
import { ExpensesResponseModel } from "@gtpl/shared-models/finance";

@ApiTags('expenses')
@Controller('expenses')
export class ExpensesController {
    constructor(
        private service: ExpensesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }



    @Post('/ExpensesService')
    @ApiBody({type:ExpensesDTO})
    async ExpensesuploadExcel(@Body() data:any): Promise<ExpensesResponseModel>{
       try{
        return this.service.ExpensesuploadExcel(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(ExpensesResponseModel,err);
       }
    }


    @Post('/getExpenses')
    async getExpenses(): Promise<ExpensesResponseModel> {
        try {
            return this.service.getExpenses();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(ExpensesResponseModel, err);

        }
    }

}